import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/news-categories/")({
  loader: () => {
    throw redirect({ to: "/topics", statusCode: 301 });
  },
  component: () => null,
});
